<lib-app-icon [icon]="getIconByTemperature(temperature)" [size]="'16x16'" />
